import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from '../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../Terms';

import { commonStyles } from '../../../styles/styles';
import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";



const SixthPage = ({ classes, form, previousPage, ...props }) => {
  const { handleSubmit} = props;
  
  const checkboxValue =
    form.registration && form.registration.values && form.registration.values.Terms;
  return (
      <div className={classes.regFormWrapper}  style={{maxHeight:'70vh', overflow:'scroll'}}>
        <form className="pr-3 pl-3" onSubmit={handleSubmit} style={{top:170, height:'100%',overflow:'auto'}}>
        <div>
        

<p>I declare that I understand and agree to the following:</p>
<p></p>
 <p className={classes.para}>• I understand how the assessment will take place;</p>
 <p className={classes.para}>• I know of and understand the Appeals Procedure;</p>
 <p className={classes.para}>• I have the required learning resources;</p>
 <p className={classes.para}>• I believe that my special needs, if any, have been adequately addressed;</p>
 <p className={classes.para}>• I understand how the Unit Standards fit into the qualification (if applicable);</p>
 <p className={classes.para}>• I understand the Assessment instrument/s that will be used;</p>
 <p className={classes.para}>• I understand the evidence needed for achieving the outcomes of the programme;</p>
 <p className={classes.para}>• I understand the principles of assessment;</p>
 <p className={classes.para}>• I understand that Cornerstone Performance Solutions embraces the fundamental benefits of
group work whereby we can share diverse perspectives and challenge assumptions with one
another. However, the assessment submissions required as part of my portfolio of evidence
will be my own work and not copied from a peer or internet sources. Cornerstone has the
right to impose disciplinary action if found guilty of plagiarism;</p>
 <p className={classes.para}>• I understand that that should I not finish the programme within the contractual period, and I
wish to finish the programme with Cornerstone, that I will be liable to pay the necessary
penalties as stipulated by Cornerstone‘s Late Completion Policy.</p>

<p>PoPI</p>

<p>Cornerstone requires personal information to provide a service to the applicant and is legally
obligated to collect, use and disclose personal information for the purposes of:</p>
 <p className={classes.para}>• reporting skills development initiatives to the Department of Higher Education and Training;</p>
 <p className={classes.para}>• reporting enrolments and achievements of programmes to the South African Qualifications
Authority;</p>
 <p className={classes.para}>• registering learners on the BankSETA portal for registration of learnership;</p>
 <p className={classes.para}>• reporting on quality assurance functions to the Quality Council of Trades and Occupations;</p>
 <p className={classes.para}>• compiling statistics and other research reports;</p>
 <p className={classes.para}>• providing personalised communications;</p>
 <p className={classes.para}>• complying with the law;</p>
 <p className={classes.para}>• keep records in storage to ensure that a student can have access to their qualifications and
history at the institution; </p>
 <p className={classes.para}>• and/or for a purpose that is ancillary to the above.</p>

<p>Cornerstone will not process personal information for a purpose other than those, which are
identified above without obtaining consent to further processing beforehand.</p>
 <p className={classes.para}>• I hereby provide authorisation to Cornerstone to process the personal information provided
for the purpose stated;</p>

 <p className={classes.para}>• I understand that withholding of or failure to disclose personal information will result in
Cornerstone being unable to perform its functions and/or any services or benefits I may
require from Cornerstone;</p>
 <p className={classes.para}>• Where I shared personal information of individuals other than myself with Cornerstone, I
hereby provide consent on their behalf to the collection, use and disclosure of their personal
information in accordance with this consent provided and I warrant that I am authorised to
give this consent on their behalf;</p>
 <p className={classes.para}>• To this end, I indemnify and hold Cornerstone harmless in respect of any claims by any other
person on whose behalf I have consented, against Cornerstone should they claim that I was
not so authorised;</p>
 <p className={classes.para}>• I understand that in terms of POPI and other laws of the country, there are instances where
my express consent is not necessary to permit the processing of personal information, which
may be related to police investigations, litigation, the fulfilment of a legal obligation, or
when personal information is publicly available. I will not hold Cornerstone responsible for
any improper or unauthorised use of personal information that is beyond its reasonable
control.</p>

<p>Student Declaration</p>
<p>I, hereby, declare that:</p>
 <p className={classes.para}>• All the information and answers provided in my assessments and activity worksheets will be
my own work;</p>
 <p className={classes.para}>• I will not copy from other people nor provide them with my answers; and</p>
 <p className={classes.para}>• I will keep my Username and Password confidential to prevent plagiarism and/or fraud; and</p>
 <p className={classes.para}>• I understand that should I be found guilty of plagiarism and/or copying from other students
or sources, I am committing Academic Fraud and disciplinary steps will be followed as
agreed between Cornerstone and the relevant employer.</p>
                 </div>
     
          <div className={`${classes.halfField2} ${classes.noTopLabel}`}>
            <Field
              name="Terms"
              component={RenderCheckbox}
              label=""
              checkedStatus={checkboxValue}
             
            />
          </div>
          <div>
          <MDBRow className="mt-2">
            <MDBCol size="6">
              <MDBBtn 
                  right
                  size="md"
                  className='mt-0 mb-2 float-left danger-color-dark'
                  action
                  onClick={previousPage}
                  type="button">
                PREVIOUS
              </MDBBtn>
            </MDBCol>
            <MDBCol size="6">
              <MDBBtn color="success"
                  right
                  size="md"
                  className='ml-3 mr-2 mt-0 mb-2 float-right'
                  action
                  type="submit">
                REGISTER
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </div>
      </form>
    </div>
  ) 
}



SixthPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const styles = () => ({
  ...commonStyles,
  halfField2: {
    display: 'inline-flex',
    width: '75%',
  },
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    margin: '0 auto 200',
    padding: '0 10'
    
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'PTSans-Bold',

  },
  para:{
    fontFamily: 'PTSans-Regular',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'left'
  },
  title:{
    fontFamily: 'PTSans-Bold',
    fontSize: '18px',
    lineHeight: '22px',
  }
});

export default compose(
  reduxForm({  form: 'registration',                 // <------ same form name
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
}),
withStyles(styles),
)(SixthPage);
